<div class="container-fluid">
<section>
	<header>
		<h1><span jhiTranslate="program-settings-manager.title">Manage Program Settings</span>&nbsp;
            <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
		</h1>
	</header>
	<nav>
		<ul class="nav nav-tabs">
			<li class="nav-item pe-1">
				<a class="nav-link" [routerLink]="['basic-details']" [routerLinkActive]="['active']" queryParamsHandling="merge"
				   jhiTranslate="program-settings-manager.tabs.basic-details"></a>
			</li>
			<li class="nav-item pe-1">
				<a class="nav-link" [routerLink]="['members']" [routerLinkActive]="['active']" queryParamsHandling="merge"
				   jhiTranslate="program-settings-manager.tabs.members"></a>
			</li>
			<li class="nav-item pe-1">
				<a class="nav-link" [routerLink]="['locations']" [routerLinkActive]="['active']" queryParamsHandling="merge"
				   jhiTranslate="program-settings-manager.tabs.locations"></a>
			</li>
			<li class="nav-item pe-1">
				<a class="nav-link" [routerLink]="['breeding-methods']" [routerLinkActive]="['active']" queryParamsHandling="merge"
				   jhiTranslate="program-settings-manager.tabs.breeding-methods"></a>
			</li>
		</ul>
	</nav>
	<div class="tab-content p-3">
		<router-outlet></router-outlet>
	</div>
</section>
</div>
